module.exports = __webpack_public_path__ + "img/logo-tcdc.492887e0.png";